/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal, Box } from '@mui/material';
import { sendRequest } from '../../../api/shootAPI';
import API from '../../../api/endpoints';
import { NotificationContext } from '../../../contexts/Notification';

function EditDesignationModal({
  designation, isEditing, closeModal, onDesignationSaved, workspaceId,
}) {
  const { displayNotification } = useContext(NotificationContext);
  const [isSaving, setIsSaving] = useState(false);
  const [name, setName] = useState(designation?.name ?? '');
  const [formErrors, setFormErrors] = useState({});

  const handleSaveDesignation = async () => {
    setIsSaving(true);
    const { data, success } = await sendRequest({
      method: 'post',
      url: API.WORKSPACE.designation(workspaceId),
      data: { name, id: designation?.id ?? null },
    });
    if (success) {
      onDesignationSaved();
      closeModal();
      displayNotification({ message: 'Designation saved successfully.', severity: 'success' });
    } else {
      setFormErrors(data || {});
      displayNotification({ message: 'Error occurred while saving designation.', severity: 'error' });
    }
    setIsSaving(false);
  };

  const disabled = isSaving || !name || (designation ? designation.name === name : false);

  return (
    <Modal open onClose={closeModal} className="flex-row align-c jstfy-c">
      <Box style={{ width: 489, maxWidth: 'calc(100% - 32px)', padding: 24, background: '#fff', borderRadius: 12 }}>
        <h5 className="text-lg font-semibold leading-none text-ink-900 mb-5">{`${isEditing ? 'Edit' : 'Add'} Designation`}</h5>
        <div className="mb-5">
          <span className="block text-sm font-medium text-ink-900 mb-1.5">Designation Name</span>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Senior Engineer"
            className="w-full h-10 px-3 border border-rule rounded-[8px] text-sm text-ink-900 placeholder:text-ink-500 focus:outline-none focus:border-brand-500"
            style={{ borderStyle: 'solid' }}
          />
          {formErrors?.name ? <p className="text-xs text-[#CC4525] mt-1.5">{formErrors.name}</p> : null}
        </div>
        <div className="flex justify-start items-center gap-2">
          <button
            type="button"
            onClick={closeModal}
            className="inline-flex items-center justify-center px-4 py-2 border border-rule rounded-[8px] text-sm font-medium text-ink-900 bg-white hover:bg-gray-50 transition"
            style={{ borderStyle: 'solid' }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSaveDesignation}
            disabled={disabled}
            className="inline-flex items-center justify-center px-4 py-2 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition"
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {isSaving ? 'Saving…' : isEditing ? 'Save Changes' : 'Save Designation'}
          </button>
        </div>
      </Box>
    </Modal>
  );
}

EditDesignationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onDesignationSaved: PropTypes.func.isRequired,
  designation: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  isEditing: PropTypes.bool.isRequired,
  workspaceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

EditDesignationModal.defaultProps = { designation: {} };

export default EditDesignationModal;
